module.exports = __webpack_public_path__ + "img/textbox.d8c499e6.png";